import { SecurityRequirementElement } from '@swagger-api/apidom-ns-openapi-3-0';
class SecurityRequirement extends SecurityRequirementElement {}
export default SecurityRequirement;